module.exports = __webpack_public_path__ + "static/media/trophy.1a1703bb.svg";